import { render, staticRenderFns } from "./CheckoutPaymentFailed.vue?vue&type=template&id=eb143fcc"
import script from "./CheckoutPaymentFailed.vue?vue&type=script&lang=js"
export * from "./CheckoutPaymentFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports